import useOptions from "hooks/useOptions"
import { useTranslation } from "react-i18next"
import { Autocomplete } from "./Autocomplete"

interface EnumSelectProps {
    required?: boolean
    disabled?: boolean
    filter?: boolean
    name: string
    optionsEnum: Record<string, string>
    label: string
    tPrefix: string
    loading?: boolean
    size?: "small" | "medium" | undefined
    multiple?: boolean
    limitTags?: number
    readonly?: boolean
    helperText?: string
    getOptionDisabled?: (option: string) => boolean
}

const EnumSelect = (props: EnumSelectProps) => {
    const { t } = useTranslation()
    const {
        helperText,
        readonly = false,
        required = false,
        disabled = false,
        filter = false,
        name,
        optionsEnum,
        label,
        tPrefix,
        loading = false,
        size,
        multiple,
        limitTags,
        getOptionDisabled,
    } = props

    const options = useOptions(optionsEnum)
    return (
        <Autocomplete
            placeholder={filter && !required ? t("formInput.arraySelectPlaceholder") : undefined}
            label={label}
            name={name}
            options={options}
            getOptionLabel={(option) => (option ? t(`${tPrefix}.${option}` as const) : "")}
            required={required}
            disabled={disabled}
            getOptionDisabled={getOptionDisabled}
            loading={loading}
            size={size}
            helperText={helperText}
            multiple={multiple}
            limitTags={limitTags}
            readOnly={readonly}
            fullWidth
        />
    )
}

export default EnumSelect
